import type { ReactNode } from 'react';
import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import { cn } from '@shared/lib/cn';

type Tone = 'error' | 'success' | 'info';

const TONES: Record<Tone, { wrapper: string; Icon: typeof Info }> = {
  error: { wrapper: 'bg-red-50 text-red-800 border-red-200', Icon: AlertCircle },
  success: { wrapper: 'bg-emerald-50 text-emerald-800 border-emerald-200', Icon: CheckCircle2 },
  info: { wrapper: 'bg-blue-50 text-blue-800 border-blue-200', Icon: Info },
};

export interface AlertProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

export function Alert({ tone = 'info', children, className }: AlertProps) {
  const { wrapper, Icon } = TONES[tone];

  return (
    <div
      // Errors interrupt; anything else waits for a pause in speech.
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn('flex items-start gap-2 rounded-md border px-3 py-2 text-sm', wrapper, className)}
    >
      <Icon aria-hidden className="mt-0.5 h-4 w-4 shrink-0" />
      <div>{children}</div>
    </div>
  );
}
